
    import {defineComponent, reactive, computed, ComputedRef, watch} from 'vue'
    import {useRoute} from "vue-router";
    import {useStore} from "@/store";
    import  reportMsgUt from "@/util/reportMsg";
    import { Tab, Tabs } from 'scvant';

    interface State {
        activeName: string;
        contentText: object;
        reportTemplate: string;
        reportMsg: object;
        reportFreeCheckVersion: any;
    }
    export default defineComponent({
        name: "explainFreeCheck",
        components: {
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
        },
        setup() {
            let state: State = reactive({
                reportTemplate: '299',
                activeName: '90天收购保障范围',
                contentText: {},
                reportMsg: {},
                reportFreeCheckVersion: null
            })
            state.reportMsg = reportMsgUt;
            let store = useStore()
            const {query} = useRoute();
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            // watch(dataInfo, (data: any) => {
            //     const {reportFreeCheckVersion} = data
            // })
            state.reportFreeCheckVersion = query.reportFreeCheckVersion
            
            
            state.contentText = {
                '299': 
                [
                    {
                        title: '90天收购保障及重要部件、调表赔付保障范围',
                        label: '保障范围',
                        content: [
                            '通过268V实车检测的车辆，自检测报告出具后90日内且您作为出售方首次出售该车辆所有权登记转移完成前，若您发现被检测车辆为重大事故、火烧、泡水车，或车辆的发动机、变速箱出现拆装痕迹、漏油、渗油、修复痕迹或调表的情况，检测报告未准确反映的，同时，满足我们和您签署的《检测服务合同》（以下简称“主合同”）约定的条件的，268V按照主合同的标准向您承担赔付责任。',
                        ]
                    },
                    {
                        title: '保障时间',
                        content: [
                            '保障期间是检测报告出具后90日内且您作为出售方首次出售该车辆所有权登记转移完成前。',
                        ]
                    },
                    {
                        title: '承保流程',
                    },
                    {
                        title: '保障对象',
                        content: [
                            '我们的保障对象包括您（也即：委托方）。',
                        ]
                    },
                    {
                        title: '承保范围',
                        content: [
                            '<b>1、“三非”检测失误:</b>',
                            'prop_up_height12',
                            '(1)被检车辆在检测报告出具前是重大事故车、火烧车或泡水车而我们出具的检测报告未显示该情况的，经我们复检确认后，按照下列标准承担责任:<b>我们或我们的指定方按照交易价格购买该车辆，或者就承保受益人购车的交易价格和处置价格的差价进行差额补偿。</b>',
                            '交易价格指:被检车辆在检测报告出具后90天内，承保受益人购买被检车辆的成交价格;处置价格指:被检车辆被判定为重大事故、火烧、泡水判定错误后以拍卖方式处置的价格。 ',
                            'prop_up_height12',
                            '<b>(2) 交易价格合理性评估:我们有权对交易价格合理性进行评估，如交易价格超出市场合理价5%的，我们仅能以市场合理价为上限进行赔付，超出部分不赔付。</b>',
                            'prop_up_height12',
                            '<b>(3)自检测报告出具后，车辆出现新增明显损伤的，车辆赔付金额应扣除损伤维修费和新增损伤带来的二次销售车价折损。</b>',
                            'prop_up_height12',
                            '<b>2、发动机、变速箱检测失误:</b> ',
                            'prop_up_height12',
                            '(1)被检车辆在检测报告出具前变速箱主体出现拆装痕迹、漏油、渗油、修复痕迹，检测报告未体现的，且与检测报告录入的汽车公里数照片显示的公里数差额不超过500公里，<b>在承保期限内我们负责维修。</b>',
                            'prop_up_height12',
                            '(2)被检车辆在检测报告出具前发动机主体(不含皮卡、油改气车辆、转子发动机车辆、纯电、混合动力车辆、 燃料电池车)出现拆装痕迹、漏油、渗油、修复痕迹、油改气，检测报告未体现的，且与检测报告录入的汽车公里数照片显示的公里数差额不超过500公里，<b>在承保期限内我们负责维修。</b>',
                            'prop_up_height12',
                            '<b>(3)发动机、变速箱承保标准特别说明:</b>',
                            '被检车辆同时符合不存在重大事故、火烧和泡水任一情形，且变速箱、发动机不存在承保标准中列明的问题的，才被判定为符合承保标准;',
                            '如果被检车辆不存在重大事故、火烧或泡水任一情形，但变速箱或发动机任一部件不符合承保标准的，我们仅对车辆的重大事故、火烧或泡水情形进行承保;',
                            '如果被检车辆存在重大事故、火烧或泡水任一情形的，不论变速箱或发动机是否符合承保标准，<b>我们均不予承保，</b>您应当审慎进行交易及其他任何决策。',
                            'prop_up_height12',
                            '3、如果被检车辆满足重大事故、火烧、泡水判定失误的，即使同时满足其他赔付条件，我们也仅按照重大事故、火烧、泡水判定失误的赔付标准进行赔付。 ',
                            'prop_up_height12',
                            '<b>4、调表检测失误：</b> ',
                            'prop_up_height12',
                            '被检车辆在检测报告出具前曾对车辆里程数据篡改而我们出具的检测报告未显示该情况的，经我们复检确认后，<b>按照调表检测失误的赔付标准进行赔付。</b> ',
                        ]
                    },
                    {
                        title: '您如何索赔',
                        content: [
                            '1)索赔时效：您仅可在检测报告出具90日内且您作为出售方首次出售该车辆所有权登记转移完成前发起索赔申请，检测报告出具满90日后或您作为出售方首次出售该车辆且已经完成车辆所有权登记转移的，您无权向我们要求赔偿。 ',
                            'prop_up_height12',
                            '2)经我们复检确认实车检测评估报告错误，您需在收到通知之日起（含当日）7个自然日内提交所有资料，否则视为放弃索赔。',
                            'prop_up_height12',
                            '3)索赔完成后，检测报告失效，我们对该车的承保责任结束。',
                            'prop_up_height12',
                            '4)索赔所需材料：您向我们提出检测报告错误赔偿请求，有义务提供如下材料：',
                            'a. 我们的检测报告；',
                            'b. 您的身份证、车辆登记证、书面索赔申请； ',
                            'c. 能够证明我们检测存在失误的其他任何材料；',
                            'd. 其他我们认为必要且合理的文件。',
                        ]
                    },
                    {
                        title: '双方权利义务',
                        content: [
                            '<b>1、您在下单购买本服务时，即视为您是车辆所有权人或已获得车辆所有权人的充分授权。若您未获得车辆所有权人授权同意而下单购买本服务导致的任何纠纷与我们无关，由您独自承担上述行为导致的全部法律责任。</b>',
                            'prop_up_height20',
                            '<b>2、检测师开始检测后，如因您的原因中途放弃检测或检测完成后不认可检测报告的，不可退款。</b>',
                            'prop_up_height20',
                            '3、我们至迟在检测完成后48小时内出具检测报告，您应当在收到检测报告后再进行交易或其他决策。<b>您未认真阅读检测报告而导致的损失，我们不承担相关责任。</b>',
                            'prop_up_height20',
                            '4、注意事项：',
                            '(1)我们并非检测车辆部件的功能状态、改装情况或其他。',
                            'prop_up_height20',
                            '<b>(2)受限不可检：检测过程中如遇车辆结构、检测环境以及其他因素导致检测项目无法检测，或局部部件需拆解或举升才能检测，但车主或委托人未同意或未授权造成无法检测，我们将会在检测报告中或补充说明中明确提示该部位“受限不可检”。<u>因受限不可检造成车辆结论有误的，我们不承担任何责任。若车主或委托人不配合检测导致我们检测师无法完成车辆检测的，则检测终止，且我们有权不退检测费用。</u>前述“车主或委托人未同意或未授权”包括：A. 车主或委托人以口头或书面形式明确告知我们检测师不同意或不授权; 或者B. 我们检测师以书面形式（包括微信等）获取车主或委托人同意或授权，车主或委托人【2】分钟内未予以答复的，视为“车主或委托人未同意或未授权”。</b>',
                            'prop_up_height20',
                            '(3)您发起索赔后，我们有权自行或委派第三方对被检车辆进行复查、勘验，您有义务予以配合。',
                            'prop_up_height20',
                            '(4)您对我们的复检结论、收购价格等存在异议的，可自行委托其他具备二手车评估鉴定资质的第三方机构按照GB∕T 30323-2013《二手车鉴定评估技术规范》国家标准和T/CADA 18-2021《乘用车鉴定评估技术规范》CADA团体标准规定的程序出具鉴定评估报告，并及时提交给我们。经我们或者生效法律文书确认我们的复检结论有误的，我们将承担鉴定评估费用，但最多不超过1500元；经我们或者生效法律文书确认我们的复检结论无误的，该鉴定评估费用由您自行负担。',
                        ]
                    },
                    {
                        title: '268V免责',
                        weight: 'bold',
                        content: [
                            '具备下列情形之一的，268V免责：',
                            'prop_up_height12',
                            '1.检测报告出具后超过90天有效期或您已经销售该车辆并完成所有权登记转移的，您（委托方）无权再发起索赔；',
                            'prop_up_height12',
                            '2.我们的检测服务是为了提升交易效率，保障消费者的合法权益，并不免除车辆卖方的法定责任，如我们发现您在明知车辆存在重大事故、火烧、泡水情况或其他严重缺陷情况下交易的，我们不承担任何保障和赔付责任；',
                            'prop_up_height12',
                            '3.检测报告出具后，车辆在报告激活期限内未转移登记或在报告激活期限内未激活的，报告及对应承诺失效；',
                            'prop_up_height12',
                            '4.检测报告出具后，不论是否激活，车辆转移登记次数超过1次的，报告及对应承诺失效；',
                            'prop_up_height12',
                            '5.承保激活后车辆再次转移登记的，承保失效，激活受益人及再次购买人无权索赔；',
                            'prop_up_height12',
                            '6.您提出异议的时间超过对应的承保期限；',
                            'prop_up_height12',
                            '7.您未在我们通知提交索赔材料的7个自然日内提供合法、有效的各类必要证明材料及索赔材料的；',
                            'prop_up_height12',
                            '8.受限不可检：已经在检测报告中予以提示的，则相关部件的真实情况或因此造成车辆结论有误的情况不在我们车辆检测保障承诺范围内；',
                            'prop_up_height12',
                            '9.检测报告仅可接受一次索赔，我们赔付完后，报告及对应承诺失效，您或受益人均无权索赔；',
                            'prop_up_height12',
                            '10.因结构件改装（含改装打孔、改装切割、改装焊接、改装变形、改装更换）导致的损伤不在重大事故车判定标准范畴，因此引发的争议不属于检测失误；',
                            'prop_up_height12',
                            '11.如因您或车辆本身问题，如车辆部件贴透明材料或改色车衣、改装车辆隔音、加装车辆底盘装甲、改装车辆地板以及其他变更车辆实际的情况，车辆部件异常缺陷的，无法确认部件状况，上述情况导致我们根据当前检测标准和技术客观无法准确检测的，或因您改装部件影响相关评级的，不视为我们检测错误，我们无需向您承担本协议项下的赔付责任；',
                            'prop_up_height12',
                            '12.ECU检测所展示的车辆运行数据均为静态数据，检测报告中ECU的诊断结果信息仅供参考；',
                            'prop_up_height12',
                            '13.您因各类原因未能配合我们或我们委派的第三方或保险公司对车辆进行复查和勘查的；',
                            'prop_up_height12',
                            '14.检测当日车辆的真实状况不足以反映车辆曾发生过重大事故、火烧、泡水问题的；',
                            'prop_up_height12',
                            '15.我们出具车辆检测报告后因任何原因导致车况状态发生变化，并因此导致检测结果不再适用的；',
                            'prop_up_height12',
                            '16.《268V检测认定标准》会不定期更新，如有更新，我们会通过系统通知您。新标准上线后我们会使用新标准进行检测和输出报告。您知晓并同意我们使用新标准检测并输出报告，且因新旧标准不同导致的检测报告不一致的我们免责。',
                            'prop_up_height12',
                            '17.因不可归责于我们的原因造成被检车辆损失扩大的，我们就扩大部分损失免责；',
                            'prop_up_height12',
                            '18.被检车辆存在违反《中华人民共和国道路交通安全法》第十六条所规定情形的，我们免责，并可以将违法线索移送公安机关依法处理。上述情形包括：拼装机动车或者擅自改变机动车已登记的结构、构造或者特征；改变机动车型号、发动机号、车架号或者车辆识别代号；伪造、变造或者使用伪造、变造的机动车登记证书、号牌、行驶证、检验合格标志、保险标志；使用其他机动车的登记证书、号牌、行驶证、检验合格标志、保险标志。',
                        ],
                    },
                ]
            }
            return {
                state
            }
        },
        methods: {
            goBack(){
                history.go(-1)
            }
        }
    })
